<div class="sidebar-tab-page-content copo-no-user-select sidenav-content" cdkScrollable>
	<copo-panel-header (backButtonClick)="goBack()" [titleHeaderText]="('eoffer.offer.request' | translate)+' - '+('draftoffer.list' | translate)">
	</copo-panel-header>

	<ng-container *ngIf="!isLoading else loading">
		<div class="grid-6 copo-container" copoVirtualScroller [dataId]="dataId" #scroller="copoVirtualScroller"
			(moreDataNeeded)="onMoreDataNeeded($event.index, $event.limit, $event.provideData)">
			<div *ngFor="let offer of scroller.list" class="grid-column-one-full card-block">
				<div class="card-portal">
					<div class="card-header">

						<div class="card-header-left">
							<mat-icon svgIcon="ordered" class="header-margin-right"></mat-icon>
							<span class="header-margin-right">{{ getOfferDraftName(offer) }}</span>
						</div>

					</div>

					<div class="card-content">
						<div class="card-container-column-draft">
							<span class="card-content-label-draft draft-title" translate>draft.selected.product</span>
							<span>{{getSelectedProduct(offer) }}</span>
						</div>

						<div class="card-container-column-draft">
							<span class="card-content-label-draft draft-title" translate>draft.total.tons</span>
							<span>{{getTotalTons(offer) }}</span>
						</div>
						<div class="card-container-column-draft">
							<span class="card-content-label-draft draft-title" translate>draft.creationdate</span>
							<span>{{ offer.creationDate | copoDate:'date' }}</span>
						</div>
						<div class="card-container-column-draft">
							<span class="card-content-label-draft draft-title" translate>draft.lastupdate</span>
							<span>{{ offer.modificationDate | copoDate:'date' }}</span>
						</div>
						<div class="card-container-column-draft card-column-around">
							<div class="card-container-link">
								<button type="button" mat-icon-button class="draft-box-shadow-icon card-container-large-link-span"
									(click)="evtContinueDraft(offer.id)"
									[matTooltip]="'continue.draft' | translate">
									<mat-icon color="accent" svgIcon="copo_pencil" class="image-draft-list-icon"></mat-icon>
								</button>
								<button type="button" mat-icon-button class="draft-box-shadow-icon card-container-large-link-span"
									(click)="evtDeleteDraftOffer(offer.id, offer.customerOfferReference)"
									[matTooltip]="'delete.draft' | translate">
									<mat-icon color="accent" svgIcon="garbage" class="image-draft-list-icon"></mat-icon>
								</button>
							</div>
							<div class="card-container-link draft-list-viewdetails">
								<a mat-button color="primary" (click)="$event.preventDefault();evtGoToOfferCard(offer.id)" href="#">
									<span
										translate>delivery-tracking.view-details</span>
									<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
								</a>

							</div>
						</div>
					</div>
				</div>

				<div class="card-mobile">
					<div class="card-header">
						<div class="card-header-left">
							<mat-icon svgIcon="ordered" class="header-margin-right"></mat-icon>
							<span class="header-margin-right overflow-wrap">{{ getOfferDraftName(offer) }}</span>
						</div>

					</div>

					<div class="card-content">
						<div class="content-grid-mobile">
							<div class="card-container-column-draft">
								<span class="card-content-label-draft draft-title" translate>draft.selected.product</span>
								<span class="overflow-wrap">{{getSelectedProduct(offer) }}</span>
							</div>

							<div class="card-container-column-draft">
								<span class="card-content-label-draft draft-title" translate>draft.total.tons</span>
								<span class="overflow-wrap">{{getTotalTons(offer) }}</span>
							</div>
							<div class="card-container-column-draft">
								<span class="card-content-label-draft draft-title" translate>draft.creationdate</span>
								<span class="overflow-wrap">{{ offer.creationDate | copoDate:'date' }}</span>
							</div>
							<div class="card-container-column-draft">
								<span class="card-content-label-draft draft-title" translate>draft.lastupdate</span>
								<span class="overflow-wrap">{{ offer.modificationDate | copoDate:'date' }}</span>
							</div>
						</div>
						<div class="card-container-column-draft card-column-around">
							<div class="card-container-link">
								<button type="button" mat-icon-button class="draft-box-shadow-icon card-container-large-link-span"
									(click)="evtContinueDraft(offer.id)"
									[matTooltip]="'continue.draft' | translate">
									<mat-icon color="accent" svgIcon="copo_pencil" class="image-draft-list-icon"></mat-icon>
								</button>
								<button type="button" mat-icon-button class="draft-box-shadow-icon card-container-large-link-span"
									(click)="evtDeleteDraftOffer(offer.id, offer.customerOfferReference)"
									[matTooltip]="'delete.draft' | translate">
									<mat-icon color="accent" svgIcon="garbage" class="image-draft-list-icon"></mat-icon>
								</button>
							</div>
							<div class="card-container-link draft-list-viewdetails">
								<a mat-button class="draft-list-viewdetails" color="primary" (click)="$event.preventDefault();evtGoToOfferCard(offer.id)" href="#">
									<span
										translate>delivery-tracking.view-details</span>
									<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
								</a>

							</div>
						</div>


					</div>
				</div>

			</div>
			<copo-loading-spinner class="grid-column-one-full" *ngIf="scroller.loading"></copo-loading-spinner>
			<div translate class="empty-page-text grid-column-one-full"
				*ngIf="!scroller.loading && scroller.list.length === 0">order-tracking.no.result</div>
		</div>
	</ng-container>
	<ng-template #loading>
		<copo-loading-spinner></copo-loading-spinner>
	</ng-template>

</div>